<script>
import axios from '@/utils/axios';

export default {
inject: ['setLoading'],  
  data() {
    return {
     errors: {},
     id: '',
     type: '',
     code: '',
     name: '',
     image: null,
     image_preview: null,
     image_folder: 'document-templates',
    };
  },
  computed: {
   
  },
  mounted(){
   
  },
  methods: {
   documentTemplate(row = null){
    this.resetForm();
    this.image_preview = null;
    if(row !== null){
     this.id = row.id;
     this.type = row.type;
     this.code = row.code;
     this.name = row.name;
     this.image_preview = row.image ? row.image_url : null;
    }
   },

   handleImageUpload(event){
    const file = event.target.files[0];
    this.image = file;
    if(file){
     this.image_preview = URL.createObjectURL(file);
    }else{
     this.image_preview = null;
    }
   },

   async saveDocumentTemplate(){
    this.errors = {};
    this.setLoading(true); 

    try{
      const formData = new FormData();
      formData.append('id', this.id || '');
      formData.append('type', this.type);
      formData.append('code', this.code);
      formData.append('name', this.name);

      if(this.image) formData.append('image', this.image); 

     let response = [];
     if(this.id){
      //UPDATE
      response = await axios.post('/document-templates/update', formData, {
       headers: { 'Content-Type': 'multipart/form-data',},
      });
     }else{
      //CREATE
      response = await axios.post('/document-templates/create', formData, {
       headers: { 'Content-Type': 'multipart/form-data',},
      });
     }
     this.$swalToast(response.data.message);
     this.$emit('updated'); 
     this.$closeModal('document_template_modal');
     this.resetForm();
    }catch(error){
     if(error.type == 'validation'){  
      this.errors = error.errors;
     }else{
      this.$swalToast(error.message, 'error');
     }
    }finally{
     this.setLoading(false); 
    }
   },

  async deleteDocumentTemplate(){
   this.errors = {};
   this.setLoading(true); 
   try{
    const response = await axios.delete(`/document-templates/${this.id}/delete`);
    this.$swalToast(response.data.message);
    this.$emit('updated');
    this.$closeModal('document_template_delete_modal');
   }catch(error){
    if(error.type == 'validation'){
     this.errors = error.errors;
    }else{
     this.$swalToast(error.message, 'error'); 
    }
   }finally{
    this.setLoading(false);
   }
  }, 

  resetForm() {
   this.id = null;
   this.type = '';
   this.code = '';
   this.name = '';
   this.errors = {};
   this.image_preview = null;
  },

  },
};
</script>

<template>
<!-- Add Leads -->
<div class="modal fade" id="document_template_modal">
<div class="modal-dialog modal-dialog-centered">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">{{ id ? 'Edit' : 'Add'}} Document Template</h4>
      <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
        <i class="ti ti-x"></i>
      </button>
    </div>
    <form @submit.prevent="saveDocumentTemplate" enctype="multipart/form-data">
      <div class="modal-body pb-0">
        <div class="row">

        <div class="col-md-5">
        <div class="d-flex align-items-center flex-wrap row-gap-3 bg-light w-100 rounded p-3 mb-4">
        <div class="d-flex align-items-center justify-content-center avatar-xxl bg-white rounded border border-dashed me-2 flex-shrink-0 text-dark frames px-2">
        <img v-if="image_preview" :src="image_preview" class="img-fluid" alt="Image" width="70" />
        <i v-else class="ti ti-photo fs-24 text-muted"></i>
        </div>
        <div class="profile-upload">
        <div class="mb-2">
        <h6 class="mb-1">Image</h6>
        </div>
        <div class="profile-uploader d-flex align-items-center">
        <div class="drag-upload-btn btn btn-sm btn-primary me-2">
        Change
        <input type="file" class="form-control image-sign" @change="handleImageUpload"/>
        </div>
        
        </div>
        <div v-if="errors.image" class="text-danger small mt-1">{{ errors.image[0] }}</div>
        </div>
        </div>
        </div>  

        <div class="col-md-7">
        <div class="mb-2">
        <label class="form-label">Name <span class="text-danger"> *</span></label>
        <input type="text" class="form-control" v-model="name" />
        <div v-if="errors.name" class="text-danger small mt-1">{{ errors.name[0] }}</div>
        </div>
        <div class="mb-2">
        <label class="form-label">Code <span class="text-danger"> *</span></label>
        <input type="text" class="form-control" v-model="code" />
        <div v-if="errors.code" class="text-danger small mt-1">{{ errors.code[0] }}</div>
        </div>
        <div class="mb-2">
        <label class="form-label">Type <span class="text-danger"> *</span></label>
        <select class="form-select" v-model="type">
         <option value="proposal">Proposal</option>
         <option value="quotation">Quotation</option>
         <option value="proforma_invoice">Proforma Invoice</option>
         <option value="invoice">Invoice</option>
         <option value="sales_order">Sales Order</option>
        </select>
        <div v-if="errors.type" class="text-danger small mt-1">{{ errors.type[0] }}</div>
        </div>
        </div>



        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal"> Cancel </button>
        <button type="submit" class="btn btn-primary">Save</button>
      </div>
    </form>
  </div>
</div>
</div>
<!-- /Add Leads -->

<!-- Delete Modal -->
<div class="modal fade" id="document_template_delete_modal">
<div class="modal-dialog modal-dialog-centered">
  <div class="modal-content">
    <div class="modal-body text-center">
      <span class="avatar avatar-xl bg-transparent-danger text-danger mb-3">
        <i class="ti ti-trash-x fs-36"></i>
      </span>
      <h4 class="mb-1">Confirm Delete</h4>
      <p class="mb-3">
        You want to delete all the marked items, this cant be undone once you delete.
      </p>
      <div class="d-flex justify-content-center">
        <a href="javascript:void(0);" class="btn btn-light me-3" data-bs-dismiss="modal">Cancel</a>
        <a href="javascript:void(0);" class="btn btn-danger" @click="deleteDocumentTemplate">Yes, Delete</a>
      </div>
    </div>
  </div>
</div>
</div>
<!-- /Delete Modal -->

</template>